import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import {getRefinements} from '../../../utils/edap';

import {reportSearchSubmit, showDatesPopup} from '../../../actions/search';
import {UNREFINED_KEY} from '../../../utils/listings';
import {AspectRatioCard} from '@homeaway/react-aspect-ratio-card';

function performClick({dispatch, eventrefinements, refinementKey, serpUrlFilters, modalTitle}) {
    return (evt) => {
        evt.preventDefault();

        reportSearchSubmit({
            actionLocation: 'properties-module',
            eventrefinements: '27',
            eventaction: 'card-search-click'
        });

        dispatch(showDatesPopup({
            searchLink: false,
            actionLocation: 'properties-module',
            eventrefinements,
            refinementKey,
            serpUrlFilters,
            title: modalTitle,
            tripleId: null
        }));
    };
}

export class SeeMorePropertiesRatioCardComponent extends PureComponent {
    render() {
        const {
            dispatch,
            propertyType,
            segmentKey,
            serpUrlFilters,
            title,
            lastCardUrl,
            imageSrc,
            aspectRatio = '4x3'
        } = this.props;
        const eventrefinements = getRefinements({propertyType, refinementKey: segmentKey});

        return (<a href={lastCardUrl} onClick={performClick({dispatch, eventrefinements, segmentKey, serpUrlFilters, title})}>
            <div className="SeeMorePropertiesCard" >
                <AspectRatioCard aspectRatio={aspectRatio} key={imageSrc} >
                    <div data-slot={'figure'} className="SeeMorePropertiesCard__content bg-brand">
                        <div className="SeeMorePropertiesCard__overlay"/>
                    </div>
                </AspectRatioCard>
                <h4 className="SeeMorePropertiesCard__title">{title}</h4>
            </div>
        </a>);
    }
}

export function mapStateToProps(state) {
    return {
        propertyType: state.destination.propertyType,
        inventoryCount: state.destination.segmentFilters.inventoryCount || state.destination.inventoryCount,
        abacus: state.abacus,
        segmentKey: state.destination.segmentFilters.key || UNREFINED_KEY,
        serpUrlFilters: state.destination.serpUrlFilters,
        title: state.modules.searchMessages.title
    };
}

export const SeeMorePropertiesRatioCard =
    connect(mapStateToProps)(SeeMorePropertiesRatioCardComponent);

SeeMorePropertiesRatioCard.displayName = 'SeeMorePropertiesRatioCard';

export default SeeMorePropertiesRatioCard;
